export default __webpack_public_path__ + "static/media/three_dancers_logo.2322e95a.png";